/**
 * OCP-428 - resolves the live `tenant.demo_pool_tag` setting for the
 * shared pool_tag picker, so the demo option stays consistent when the
 * setting is renamed (never hardcode the string "demo" in the UI).
 *
 * Reads the same `/v1/admin/settings` surface the Settings page uses;
 * falls back to the built-in default when settings can't be loaded (the
 * picker still works - the demo option just uses `demo`).
 */
import { useEffect, useState } from 'react';

import { api } from './api';
import { DEFAULT_DEMO_POOL_TAG } from './pool-role';

interface SettingItem {
  key: string;
  value: unknown;
}

export function useDemoPoolTag(): string {
  const [demoPoolTag, setDemoPoolTag] = useState<string>(DEFAULT_DEMO_POOL_TAG);

  useEffect(() => {
    void (async () => {
      try {
        const r = await api<{ items: SettingItem[] }>('/v1/admin/settings');
        const item = r.items.find((s) => s.key === 'tenant.demo_pool_tag');
        const value = typeof item?.value === 'string' ? item.value.trim() : '';
        if (value) setDemoPoolTag(value);
      } catch {
        // Keep the default - the picker degrades gracefully.
      }
    })();
  }, []);

  return demoPoolTag;
}
